import React from 'react'
import { Box, Tooltip } from '@mui/material';
import { CustomSlider } from '../../../../../CustomSlider/CustomSlider';


function ValueLabelComponent(props) {
    const { children, value, open } = props;

    return (
        <Tooltip
            open={open}
            enterTouchDelay={0}
            placement="top"
            title={value}
            arrow
            slotProps={{
                tooltip: {
                    sx: {
                        fontSize: '0.875rem', // Tamaño por defecto de MUI (aprox 14px)
                        padding: '4px 8px', // Padding más reducido
                    }
                }
            }}
        >
            {children}
        </Tooltip>
    );
}


export const ContractPermissionsSlider = ({ row, selectedContracts, marksNames, fieldName, fieldToInteger, handleChange }) => {

    const isSelected = selectedContracts.some(contract => contract.id === row.id);
    const selectedContract = selectedContracts.find(contract => contract.id === row.id);
    const currentValue = fieldToInteger(selectedContract?.[fieldName]) ?? (marksNames.length - 1);
    /**
     * 
    console.log("row", row)
    console.log("isSelected", isSelected)
    console.log("selectedContracts", selectedContracts)
    console.log("selectedContract", selectedContract)
    console.log("permissionsToInteger", selectedContract?.[fieldName], fieldToInteger(selectedContract?.[fieldName]))
    console.log("currentValue", currentValue)
     */

    return (
        <Box sx={{ pr: 5 }}>
            <CustomSlider
                name={`${fieldName}_${row.id}`}
                value={currentValue}
                step={1}
                min={0}
                max={marksNames.length - 1}
                disabled={!isSelected}
                onChange={(e) => handleChange(row.id, e.target.value)}
                valueLabelFormat={(value) => marksNames[value] ?? value}
                marks={marksNames.map((label, index) => ({ value: index, label: String(index) }))}
                slots={{
                    valueLabel: ValueLabelComponent,
                }}
            />
        </Box>
    )
}
